import React, { useState, useEffect } from 'react';
import {
  SidebarQuarterlyContainer,
  AccordionTitle,
  AccordionContent,
  AccordionContentFuture,
  AccordionText,
  RowStyle,
  LegendTextStyle,
  QuarterHeaderTitle,
} from '@atoms/sidebar/sidebar.styles';
import Legend from '@molecules/pursuitLeader/components/legend';
import MontlySideBar from '@molecules/pursuitLeader/components/montlySideBar';
import flagIcon from '@assets/icons/forecastIconWhite.svg';
import { formatNumberWithKAndM } from '@util/commonUtil';
import { FORECAST_SIDEBAR_QUARTER_CONST, QUARTERLY_DETAILS } from '@constants/commonConstants';

const QuarterlyExpandedSidebar = props => {
  const data = props?.data;
  const quarter = props?.quarter;
  const year = props?.year;
  const quarterTitle = props?.quarterTitle;
  const expanded = props?.expanded;
  const toggleAccordion = props?.toggleAccordion;

  const propsData = {};

  const [noCommitValue, setNoCommitValue] = useState(data['quarterlyCalculation']?.noCommit || 0);

  useEffect(() => {
    setNoCommitValue(data['quarterlyCalculation']?.noCommit || 0);
  }, [data]);

  const handleKeyPress = event => {
    if (event.code === 'Enter') {
      toggleAccordion();
    }
  };

  const addFocus = event => {
    event.target.classList.add('focusContainer');
  };

  const removeFocus = event => {
    event.target.classList.remove('focusContainer');
  };

  return (
    <>
      <SidebarQuarterlyContainer
        className={expanded ? 'expanded' : 'expanded'}
        onKeyDown={handleKeyPress}
        onFocus={addFocus}
        onBlur={removeFocus}
      >
        <AccordionTitle onClick={toggleAccordion}>
          <QuarterHeaderTitle>{quarterTitle}</QuarterHeaderTitle>
          {quarterTitle === FORECAST_SIDEBAR_QUARTER_CONST.NOW ||
          quarterTitle === FORECAST_SIDEBAR_QUARTER_CONST.NEXT ? (
            <QuarterHeaderTitle>
              {quarter} | FY {year}
            </QuarterHeaderTitle>
          ) : null}
        </AccordionTitle>

        {quarterTitle === FORECAST_SIDEBAR_QUARTER_CONST.NOW ? (
          <AccordionContent>
            {/* <CrmChartQuarterly quarterlyData={data['quarterlyCalculation']} /> */}
            <Legend
              quarterlyData={data['quarterlyCalculation']}
              quarterText={quarter}
              flagImageSrc={flagIcon}
            />
            <AccordionText style={{ color: '#ffffff' }}>
              {QUARTERLY_DETAILS.UNCOMMITED_PIPELINE}: {formatNumberWithKAndM(noCommitValue)}
            </AccordionText>
          </AccordionContent>
        ) : null}

        {quarterTitle === FORECAST_SIDEBAR_QUARTER_CONST.NEXT ? (
          <AccordionContentFuture>
            <span>{formatNumberWithKAndM(data['quarterlyCalculation']?.commit) || 0}</span>
            <RowStyle>
              <LegendTextStyle>{QUARTERLY_DETAILS.PROJECTED_FORECAST}</LegendTextStyle>
            </RowStyle>
            <AccordionText style={{ color: '#ffffff' }}>
              {QUARTERLY_DETAILS.UNCOMMITED_PIPELINE} : {formatNumberWithKAndM(noCommitValue)}
            </AccordionText>
          </AccordionContentFuture>
        ) : null}

        {data ? <MontlySideBar quarterData={data} propsData={propsData} /> : null}
      </SidebarQuarterlyContainer>
    </>
  );
};

export default QuarterlyExpandedSidebar;
